import { AxiosError } from 'axios';
import {
  createValidator,
  latinLettersOnly,
  regexp,
  required,
  tip,
  TipLevels,
} from '@unitedtraders/validators';
import { restErrorsToForm } from '@unitedtraders/microfrontend-common';
import { format, parse } from 'date-fns';
import { Instrument } from '../../../hooks/mapInstruments';
import { useWithdrawService } from '../../../hooks/useWithdrawService';
import { useAmountValidators } from '../../../components/AmountInput/hooks';
import { FormValues } from '.';
import { date } from '../../../utils/validators';

// t('validator:The SWIFT is invalid')
// t('validator:The account number (or IBAN) is invalid')
// t('validator:latins letters only')
// t('validator:should be between 15 and 31 digits')
// t('toBank:If the name is in the wrong order, the payment may not go through')
export const useFormProps = (instrument: Instrument) => {
  const withdrawService = useWithdrawService();
  const amountValidators = useAmountValidators(instrument);

  const validate = createValidator<FormValues>({
    amount: amountValidators,
    bankSwift: [required()],
    birthday: [required(), date(), regexp(/\d{2}\.\d{2}\.\d{4}/, 'validator:date')],
    clientHomeAddress: [required()],
    clientName: [required(), latinLettersOnly('validator:latins letters only')],
    iban: [required(), regexp(/\d{15,31}/, 'validator:should be between 15 and 31 digits')],
  });

  const validateTips = createValidator<FormValues>({
    clientName: [
      tip(
        'toBank:If the name is in the wrong order, the payment may not go through',
        {},
        TipLevels.TIP
      ),
    ],
  });

  return {
    validate,
    validateTips,
    onSubmit: async ({ amount, ...details }: FormValues) => {
      try {
        await withdrawService.prepareAbroadBankWithdraw(
          { value: amount, currency: instrument.currency },
          {
            ...details,
            birthday: format(parse(details.birthday, 'dd.MM.yyyy', new Date()), 'yyyy-MM-dd'),
            iban: details.iban.replace(/[^\d]/g, ''),
            bankSwift: details.bankSwift.replace(/\s/g, '').toUpperCase(),
          }
        );
        return;
      } catch (e: AxiosError | any) {
        console.log(e);
        return restErrorsToForm(e.response?.data || e);
      }
    },
  };
};
